import Cookies from './../libs/tomcat-cookies.js';

function getCookies(cookie) {
	const cookieValue = Cookies.get(cookie);
	if (cookieValue && cookieValue !== 'undefined') {
		return cookieValue;
	}
	return null;
}
const sessionKey = () => getCookies('sessionId');

const lastProduct = () => getCookies('lastProduct');

const navigation = () => getCookies('navigation');

const lovedGames = () => getCookies('lovedGames');

const recentlyPlayedGames = () => getCookies('recentlyPlayedGames');

const isoCode = () => getCookies('isocode');

const locale = () => getCookies('locale');

const justAccepted = () => getCookies('justAccepted');

const rootDomain = () => getRootDomain();

function getRootDomain() {
	return location.href.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i)[1].replace('mobile.', '').split(':')[0];
}

function setDesktopCookies() {
	Cookies.set('deviceRedirection', '443', { domain: rootDomain() });
	Cookies.set('useMobile', false, { domain: rootDomain() });
}

/**
 * Set last product cookie. It helps to determine what view to request from sever.
 *
 * @param {string} arg - It must be one of 'casino', 'shop' or 'sportsbook'
 */
function setNavigationCookies(arg) {
	if (arg !== undefined && arg != null && lastProduct() !== arg) {
		/**
		 * @deprecated 'navigation' cookie is depricated. use 'lastProduct' instead.
		 */
		console.warn(`'navigation' cookie is depricated. use 'lastProduct' instead. It'll be removed after MVP`);
		Cookies.set('navigation', arg, { path: '/' });
		Cookies.set('lastProduct', arg, { path: '/' });
	}
}

export {
	sessionKey,
	lastProduct,
	navigation,
	lovedGames,
	recentlyPlayedGames,
	isoCode,
	locale,
	justAccepted,
	setNavigationCookies,
	setDesktopCookies,
	rootDomain,
	getCookies
};



// WEBPACK FOOTER //
// ./mobile-core/src/store/cookies.js